<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M100 196.15C155.228 196.15 200 153.136 200 100.075C200 47.0142 155.228 4 100 4C44.7715 4 0 47.0142 0 100.075C0 153.136 44.7715 196.15 100 196.15Z"
    fill="url(#paint0_radial_44869_68199)" />
  <path
    d="M65.8807 176.068C53.896 176.068 45.1154 174.475 33.8594 172.134C51.8607 186.738 72.2254 196.313 97.628 195.896C156.677 194.927 193.128 158.206 199.547 109.266C169.811 149.771 121.395 176.068 65.8807 176.068Z"
    fill="url(#paint1_linear_44869_68199)" />
  <path opacity="0.33"
    d="M79.4458 39.0959C92.9592 36.5379 103.096 30.1411 102.086 24.8084C101.077 19.4757 89.3036 17.2263 75.7903 19.7843C62.277 22.3423 52.1406 28.7391 53.15 34.0718C54.1595 39.4045 65.9325 41.6539 79.4458 39.0959Z"
    fill="white" />
  <path opacity="0.2"
    d="M138.196 129.987C156.253 129.987 170.891 115.637 170.891 97.9367C170.891 80.236 156.253 65.8867 138.196 65.8867C120.14 65.8867 105.502 80.236 105.502 97.9367C105.502 115.637 120.14 129.987 138.196 129.987Z"
    fill="#30688A" />
  <path
    d="M105.062 94.7536C105.026 112.28 119.488 126.515 137.364 126.553C155.242 126.587 169.766 112.409 169.804 94.8836C169.842 77.3576 155.382 63.1219 137.502 63.086C119.625 63.0501 105.1 77.2295 105.062 94.7536Z"
    fill="#30688A" />
  <path
    d="M108.132 94.7591C108.098 110.625 121.188 123.51 137.371 123.544C153.553 123.577 166.7 110.743 166.735 94.8769C166.769 79.0137 153.678 66.1268 137.497 66.0948C121.314 66.0628 108.166 78.8958 108.132 94.7591Z"
    fill="url(#paint2_radial_44869_68199)" />
  <path opacity="0.2"
    d="M137.38 119.07C152.795 119.102 165.446 107.457 166.643 92.6413C166.7 93.3804 166.737 94.1247 166.736 94.8773C166.701 110.743 153.554 123.577 137.372 123.544C121.189 123.51 108.098 110.625 108.132 94.7594C108.134 94.0068 108.174 93.2632 108.234 92.5234C109.367 107.343 121.967 119.039 137.38 119.07Z"
    fill="#00375A" />
  <path
    d="M114.751 94.0639C114.735 102.052 121.461 108.542 129.776 108.557C138.09 108.576 144.846 102.112 144.864 94.1235C144.882 86.1339 138.154 79.6456 129.84 79.6289C121.524 79.6123 114.767 86.0736 114.751 94.0639Z"
    fill="#4EC2EE" />
  <path
    d="M120.34 94.0757C120.33 98.1114 123.73 101.39 127.929 101.399C132.131 101.407 135.544 98.1422 135.552 94.1083C135.559 90.07 132.162 86.7925 127.961 86.7842C123.76 86.7746 120.347 90.0405 120.34 94.0757Z"
    fill="#001C2D" />
  <path opacity="0.33"
    d="M130.72 91.3863C130.7 99.8851 137.856 106.788 146.702 106.807C155.549 106.824 162.734 99.9498 162.754 91.4497C162.772 82.9528 155.616 76.0482 146.77 76.0303C137.924 76.0137 130.737 82.8881 130.72 91.3863Z"
    fill="white" />
  <path
    d="M118.276 94.6353C118.27 96.6118 120.005 98.2189 122.147 98.2227C124.292 98.2278 126.032 96.6278 126.036 94.6513C126.043 92.6747 124.308 91.0702 122.163 91.0645C120.02 91.0606 118.279 92.6587 118.276 94.6353Z"
    fill="white" />
  <path opacity="0.2"
    d="M61.1546 129.957C79.2114 129.957 93.8493 115.608 93.8493 97.9074C93.8493 80.2067 79.2114 65.8574 61.1546 65.8574C43.0979 65.8574 28.46 80.2067 28.46 97.9074C28.46 115.608 43.0979 129.957 61.1546 129.957Z"
    fill="#30688A" />
  <path opacity="0.25"
    d="M61.8337 125.635C79.2281 125.635 93.3291 111.813 93.3291 94.7624C93.3291 77.7118 79.2281 63.8896 61.8337 63.8896C44.4393 63.8896 30.3384 77.7118 30.3384 94.7624C30.3384 111.813 44.4393 125.635 61.8337 125.635Z"
    fill="#30688A" />
  <path
    d="M28.5872 94.6566C28.5479 112.128 42.9666 126.32 60.7899 126.357C78.6146 126.395 93.0919 112.258 93.1326 94.7847C93.1706 77.3138 78.7539 63.1241 60.9279 63.087C43.1066 63.0505 28.6266 77.185 28.5872 94.6566Z"
    fill="#30688A" />
  <path
    d="M31.6485 94.6629C31.6118 110.478 44.6632 123.325 60.7972 123.358C76.9298 123.39 90.0358 110.596 90.0712 94.7801C90.1052 78.9642 77.0565 66.1164 60.9212 66.085C44.7872 66.0517 31.6798 78.8476 31.6485 94.6629Z"
    fill="url(#paint3_radial_44869_68199)" />
  <path opacity="0.2"
    d="M60.8047 118.899C76.174 118.929 88.788 107.321 89.9827 92.5511C90.036 93.2851 90.0734 94.03 90.0707 94.78C90.0354 110.596 76.93 123.389 60.7967 123.358C44.6627 123.325 31.6114 110.479 31.648 94.6628C31.6494 93.9141 31.6887 93.1686 31.7467 92.4326C32.876 107.209 45.4394 118.867 60.8047 118.899Z"
    fill="#00375A" />
  <path
    d="M48.647 93.9712C48.6277 101.935 55.3343 108.404 63.6223 108.422C71.9137 108.437 78.6503 101.994 78.669 94.0295C78.685 86.0661 71.9777 79.5958 63.689 79.5791C55.3963 79.5618 48.6623 86.0065 48.647 93.9712Z"
    fill="#4EC2EE" />
  <path
    d="M55.6294 93.6534C55.6221 97.6764 59.0107 100.944 63.1981 100.953C67.3847 100.962 70.7887 97.7072 70.7974 93.6836C70.8047 89.6599 67.4187 86.3927 63.2307 86.3818C59.0414 86.3748 55.6407 89.6324 55.6294 93.6534Z"
    fill="#001C2D" />
  <path opacity="0.33"
    d="M33.5865 91.2544C33.5711 98.7438 39.8771 104.83 47.6758 104.846C55.4731 104.861 61.8071 98.8002 61.8245 91.3102C61.8418 83.8176 55.5318 77.7335 47.7351 77.7168C39.9365 77.7015 33.6045 83.7638 33.5865 91.2544Z"
    fill="white" />
  <path
    d="M67.9448 95.752C67.9388 97.7221 69.6682 99.3221 71.8055 99.326C73.9408 99.3311 75.6775 97.7369 75.6822 95.7667C75.6875 93.7959 73.9588 92.194 71.8208 92.1914C69.6862 92.1837 67.9475 93.7779 67.9448 95.752Z"
    fill="white" />
  <path
    d="M68.6187 141.605C68.6187 141.605 76.686 136.989 97.808 135.095C118.929 133.198 129.33 143.891 129.33 143.891C129.33 143.891 136.809 137.093 136.072 141.191C135.333 145.288 130.434 151.397 128.134 150.246C125.834 149.093 128.693 146.566 128.693 146.566C128.693 146.566 114.407 131.899 68.6187 141.605Z"
    fill="#00375A" />
  <path
    d="M145.644 58.9799C145.644 58.9799 120.727 54.2338 122.229 44.3271C122.229 44.3271 117.076 44.7403 115.571 47.8358C114.067 50.9313 122.875 63.9322 145.644 58.9799Z"
    fill="#00375A" />
  <path
    d="M52.9072 57.8635C52.9072 57.8635 75.2139 53.6145 73.8686 44.7461C73.8686 44.7461 78.4839 45.1157 79.8306 47.8865C81.1772 50.6585 73.2919 62.2977 52.9072 57.8635Z"
    fill="#00375A" />
  <defs>
    <radialGradient id="paint0_radial_44869_68199" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(95.1468 55.7432) scale(262.018 262.021)">
      <stop offset="0.0224" stop-color="#E4F3FC" />
      <stop offset="0.4088" stop-color="#53C3EE" />
      <stop offset="0.5866" stop-color="#006EB4" />
      <stop offset="1" stop-color="#00A2DE" />
    </radialGradient>
    <linearGradient id="paint1_linear_44869_68199" x1="126.65" y1="161.217" x2="137.736" y2="184.08"
      gradientUnits="userSpaceOnUse">
      <stop offset="0.0224" stop-color="#001C2D" stop-opacity="0" />
      <stop offset="1" stop-color="#001C2D" stop-opacity="0.2" />
    </linearGradient>
    <radialGradient id="paint2_radial_44869_68199" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(137.319 95.09) rotate(-179.887) scale(29.6021 28.4402)">
      <stop stop-color="white" />
      <stop offset="0.6342" stop-color="white" />
      <stop offset="0.7821" stop-color="#EDF8FD" />
      <stop offset="1" stop-color="#CCECF8" />
    </radialGradient>
    <radialGradient id="paint3_radial_44869_68199" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
      gradientTransform="translate(61.0216 94.932) rotate(-179.888) scale(29.51 28.3517)">
      <stop stop-color="white" />
      <stop offset="0.6342" stop-color="white" />
      <stop offset="0.7821" stop-color="#EDF8FD" />
      <stop offset="1" stop-color="#CCECF8" />
    </radialGradient>
  </defs>
</svg>